export const KINDS = {
    TEXT: "Text",
    COUNTRY: "Country",
} as const;

export const SIZES = {
    REGULAR: "Regular",
    SMALL: "Small",
} as const;

export type KIND = typeof KINDS[keyof typeof KINDS];
export type SIZE = typeof SIZES[keyof typeof SIZES];
